import { ClickAwayListener, TooltipProps } from "@mui/material";
import { PropsWithChildren } from "react";

import { BigTooltip } from "./BigTooltip";

type ControlledBigTooltipProps = PropsWithChildren<{
  open: boolean;
  onClose: () => void;
}> &
  Omit<TooltipProps, "open" | "onClose">;

export const ControlledBigTooltip = ({
  open,
  onClose,
  children,
  ...props
}: ControlledBigTooltipProps) => {
  return (
    <ClickAwayListener onClickAway={onClose} disableReactTree={true}>
      <BigTooltip {...props} open={open} onClose={onClose}>
        {children}
      </BigTooltip>
    </ClickAwayListener>
  );
};
